import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllKopNamespaces, getAllNamespaces } from '@/services/utilService';

const initialState = {
  nsOptions: [],
  kopNsOptions: [],
};

export const fetchNsOptions = createAsyncThunk('util/fetchNsOptions', async (clusterName) => {
  const { data } = await getAllNamespaces(clusterName);
  return data.map((item) => ({
    label: item,
    value: item,
  }));
});

export const fetchKopNsOptions = createAsyncThunk('util/fetchKopNsOptions', async (clusterName) => {
  const { data } = await getAllKopNamespaces(clusterName);
  return data.map((item) => ({
    label: item,
    value: item,
  }));
});

export const utilSlice = createSlice({
  name: 'util',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNsOptions.fulfilled, (state, action) => {
        state.nsOptions = action.payload;
      })
      .addCase(fetchKopNsOptions.fulfilled, (state, action) => {
        state.kopNsOptions = action.payload;
      });
  },
});

export default utilSlice.reducer;
